import { Skeleton } from '@gravity-ui/uikit';

import styles from './styles.module.scss';

export const AdminTableLoader = () => {
	return (
		<div className={styles.admin_table_loader}>
			<div className={styles.admin_table_loader__main}>
				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '237px', height: '20px' }} />
					<Skeleton style={{ width: '302px', height: '20px' }} />
					<Skeleton style={{ width: '280px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '296px', height: '20px' }} />
					<Skeleton style={{ width: '252px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '302px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '296px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '252px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
					<Skeleton style={{ width: '322px', height: '20px' }} />
				</div>

				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '130px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '189px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '130px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '224px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '189px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '224px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '158px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '189px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '130px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '189px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '130px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '224px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '158px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '224px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '189px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '130px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '158px', height: '20px' }} />
				</div>

				<div className={styles.admin_table_loader__main__block}>
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
					<Skeleton style={{ maxWidth: '96px', height: '20px' }} />
				</div>
			</div>
			<div className={styles.admin_table_loader__footer}>
				<Skeleton style={{ maxWidth: '322px', height: '36px' }} />
				<Skeleton style={{ maxWidth: '64px', height: '36px' }} />
			</div>
		</div>
	);
};
